import { WhitelabelLockCta } from "features/Account/modules/Whitelabel/modules/WhitelabelLock/modules/WhitelabelLockCta/WhitelabelLockCta";
import React from "react";

export const Footer = ({ onClose }) => {
  return (
    <div className="tw-p-[16px_20px] max-md:tw-p-0 tw-bg-white tw-bg-none tw-rounded-[12px]">
      <WhitelabelLockCta onClose={onClose} />
    </div>
  );
};
